var map = {
	"./icon-tracking-bell.svg": "576d",
	"./icon-tracking-boat.svg": "4a8e",
	"./icon-tracking-new.svg": "2ed3",
	"./icon-tracking-truck.svg": "8c07",
	"./icon-tracking-upload.svg": "1b49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bfda";